let CzLabels;

export default CzLabels = {
    lbl_Titolo: 'Title',
    lbl_Tipo: "Type of registration",
    lbl_Nome: "Name",
    lbl_Cognome: "Surname",

    lbl_TipoAzienda: "Company/Organization",
    lbl_TipoPersonale: "Individual",

    lbl_Uomo: "Man",
    lbl_Donna: "Woman",
    lbl_DataDiNascita: "Date of birth",
    lbl_LuogoDiNascita: "Place of birth",
    lbl_StatoDiNascita: "Nation",
    lbl_Indirizzo: "Address",
    lbl_Provincia: "Provence",
    lbl_State: "Nation",

    lbl_CF: "Social security number",
    lbl_IVA: "Vat registration number",

    lbl_City: "City",
    lbl_Zip: "Zip",
    lbl_Cellulare: 'Mobile phone',
    lbl_TelLavoro: 'Work phone',
    lbl_TelCasa: 'Home phone',
    lbl_Email: 'Email',
    lbl_Password: 'Password',
    lbl_Password2: 'Confirm',
    lbl_email_msg: 'L\'indirizzo email serve per poter accedere al sito',


    lbl_DocumentoIdentita: 'Identity document',
    lbl_DocumentoIdentitaNazione: 'State',
    lbl_DocumentoIdentitaNumero: 'Number',
    lbl_DocumentoIdentitaScadenza: 'Exp.',
    lbl_DocumentoIdentitaFronte: 'Front image',
    lbl_DocumentoIdentitaRetro: 'Back image',
    lbl_DocumentoIdentitaData: 'Document date',

    lbl_titoloMsgErrore: 'Incomplete data',
    lbl_invalidField: 'The following fields are invalid or empty: ',

    lbl_VaiAPagina2: 'Next'
};